<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-04 15:44:01
 * @LastEditTime: 2020-09-23 13:22:12
 * @LastEditors: 杨昆(11103094)
 -->
<template>
  <div v-if="infoVideoOptions && isShowVideoDetail">
    <div class="video-container" :code="code" :class="hasRate ? 'v-rate' : ''">
      <template v-if="nativeVideo">
        <div v-if="isShowVideo" class="video-show">
          <video
            id="nativeVideo"
            :src="infoVideoOptions.videoSrc"
            controls
            muted
            autoplay
            class="native-video"
            @ended="ended"
          >
            您的浏览器不支持 video 标签。
          </video>
        </div>
      </template>
      <template v-else>
        <video-player
          v-show="isShowVideo"
          class="video-show"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="isShowVideo"
          @ended="onPlayerEnded($event)"
          @fullscreenchange="onPlayerFullScreenchange($event)"
          :events="customEvents"
        ></video-player>
      </template>
      <keep-alive>
        <div v-if="!isShowVideo" class="video-hide" @click="checkEnv">
          <img class="item-img" :src="poster" />
          <div class="start"></div>
        </div>
      </keep-alive>
      <div class="vjs-mask-app" v-show="showMaskApp">
        <p class="tip">您正在使用非Wifi网络，播放将消耗您的流量</p>
        <div class="opts">
          <a href="javascript:;" class="btn J-waiver" @click="closeVideo">不播了</a>
          <a href="javascript:;" class="btn J-confirm" @click="changeToVideo">继续播放</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 第三方包
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

// 方法
import { app } from '@/utils'
// 环境判断，QQ、官网App、微信、支付宝、农行app等环境判断
import clientEnv from '@/utils/clientEnv'

export default {
  name: 'VideoDetail',
  components: {
    videoPlayer
  },
  // inject: ['setVideoState'], // 图文详情版本，初始化时会报错，故注释
  props: {
    infoVideoOptions: {
      type: Object,
      default() {
        return {}
      }
    },
    code: [String, Number],
    hasRate: Boolean, // 视频尺寸是否是16：9
    endedCallback: Function, // 播放完成回调事件
    beforePlayCallback: Function, // 播放前回调事件
    exitFullscreenCallback: Function // 退出全屏回调事件
  },
  data() {
    return {
      isShowVideo: false,
      // 适配播放时，如果是app环境，且是移动网络，提示用户是否播放
      showMaskApp: false,
      // 安卓4.4版本之前使用原生video标签
      nativeVideo: clientEnv.isAndroid && clientEnv.androidLevel < 4.5,
      player: '',
      customEvents: ['fullscreenchange'], // 视频插件支持videojs内部事件
      inVivo: (clientEnv.isVivoApp && !clientEnv.isIOSVivoApp) || clientEnv.isVivoBrowser,
    }
  },
  computed: {
    isShowVideoDetail() {
      return this.infoVideoOptions.isShowVideoDetail
    },
    poster() {
      return this.infoVideoOptions.videoPoster
    },
    /**
     * 适配播放参数
     */
    playerOptions() {
      return {
        muted: true,
        autoplay: false,
        width: document.body.clientWidth,
        height: document.body.clientWidth - 30,
        language: 'en',
        controlBar: true,
        preload: this.infoVideoOptions.preload || 'none',
        sources: [
          {
            type: this.infoVideoOptions.videoType,
            src: this.infoVideoOptions.videoSrc,
            videoPoster: this.infoVideoOptions.videoPoster,
            videoTime: this.infoVideoOptions.videoTime
          }
        ]
      }
    },

    /**
     * 视频信息
     */
    video() {
      return this.skuInfo && this.skuInfo.videoInfo
    },

    /**
     * 视频时长
     */
    videoTime() {
      return this.video && this.video.timeLen ? this.formatTime(this.video.timeLen) : null
    }
  },
  mounted() {
    let self = this
    // 设置player
    self.setPlayer()
  },
  watch: {
    video(val) {
      if (val) {
        this.setPlayer()
      }
    }
  },
  created() {},
  methods: {
    /**
     * 暂停播放
     */
    pauseVideo() {
      try {
        this.player && this.player.pause()
      } catch (e) {}
    },
    /**
     * 重置初始化状态
     */
    resetVideoState() {
      this.isShowVideo = false
      this.showMaskApp = false
      try {
        this.player && this.player.pause()
      } catch (e) {}
    },
    /**
     * 设置player
     */
    setPlayer() {
      let _this = this
      _this.$nextTick(function () {
        _this.player =
          _this.video && _this.nativeVideo
            ? window.document.getElementById('nativeVideo')
            : _this.$refs.videoPlayer && _this.$refs.videoPlayer.player
      })
    },

    /**
     * 重新设置player，切换sku后$nextTick中取不到player信息
     */
    resetPlayer() {
      let _this = this
      _this.player =
        _this.video && _this.nativeVideo
          ? window.document.getElementById('nativeVideo')
          : _this.$refs.videoPlayer && _this.$refs.videoPlayer.player
    },

    /**
     * 视频结束时触发
     */
    onPlayerEnded(player) {
      try {
        if (player.isFullscreen()) {
          // 去除全屏
          player.exitFullscreen()
          this.exitFullscreenCallback && this.exitFullscreenCallback(this.$el)
        }
      } catch (e) {}
      this.isShowVideo = false
      this.endedCallback && this.endedCallback(this.$el)
    },

    /**
     * 全屏切换事件
     */
    onPlayerFullScreenchange(player) {
      if (!player.isFullscreen()) {
        this.exitFullscreenCallback && this.exitFullscreenCallback(this.$el)
      }
    },
    /**
     * 原生video播放结束后，退出全屏
     */
    ended() {
      let de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
        this.exitFullscreenCallback && this.exitFullscreenCallback(this.$el)
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
        this.exitFullscreenCallback && this.exitFullscreenCallback(this.$el)
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
        this.exitFullscreenCallback && this.exitFullscreenCallback(this.$el)
      }
      this.isShowVideo = false
    },

    /**
     * 检查是不是在官网app和vivo浏览器中
     */
    checkEnv() {
      if (this.inVivo) {
        this.checkApp()
      } else {
        this.$nextTick(() => {
          this.changeToVideo()
        })
      }
    },

    /**
     * 检查是否在app中，且app版本大于920，判断是否提示播放
     */
    checkApp() {
      let _this = this
      if (app.checkVersion(920)) {
        app.isMobileNet(function (isMobile) {
          // 移动网络,显示提示信息
          if (isMobile) {
            _this.showMaskApp = true
          } else {
            _this.changeToVideo()
          }
        })
      } else {
        this.changeToVideo()
      }
    },

    /**
     * 播放视频
     */
    changeToVideo() {
      this.resetPlayer()
      this.showMaskApp = false
      if (!this.nativeVideo) {
        // 触发视频播放前回调事件
        this.beforePlayCallback && this.beforePlayCallback()
        this.player && this.player.play()
      }
      this.isShowVideo = true
    },

    /**
     * 不播放视频
     */
    closeVideo() {
      this.showMaskApp = false
    },

    /**
     * 视频是否在全屏状态
     */
    isFullscreen() {
      return this.player && this.player.isFullscreen()
    },

    /**
     * 格式化时间
     */
    formatTime(seconds) {
      seconds = seconds < 0 ? 0 : seconds
      let s = Math.floor(seconds % 60)
      let m = Math.floor((seconds / 60) % 60)
      let h = Math.floor(seconds / 3600)
      if (isNaN(seconds) || seconds === Infinity) {
        h = m = s = '-'
      }
      h = h > 0 ? h + 'h' : ''
      m = (h && m < 10 ? '0' + m : m) + "'"
      s = (s < 10 ? '0' + s : s) + '"'
      return h + m + s
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
